type NavigateFn = (to: string, options?: { replace?: boolean }) => void;

let navigateImpl: NavigateFn | null = null;

/** Wired from a component under <Router> so API layers can navigate without importing react-router. */
export function setNotFoundNavigate(fn: NavigateFn | null): void {
  navigateImpl = fn;
}

const NOT_FOUND_PATH = '/404';

function getBrowserLocationKey(): string | null {
  if (typeof window === 'undefined') return null;
  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}

function normalizeTargetLocation(to: string): string {
  if (to.startsWith('http://') || to.startsWith('https://')) {
    try {
      const u = new URL(to);
      return `${u.pathname}${u.search}${u.hash}`;
    } catch {
      return to;
    }
  }
  return to;
}

export function goToNotFoundPage(): void {
  const current = getBrowserLocationKey();
  if (current !== null && normalizeTargetLocation(NOT_FOUND_PATH) === current) {
    return;
  }
  if (navigateImpl) {
    navigateImpl(NOT_FOUND_PATH, { replace: true });
  } else if (typeof window !== 'undefined') {
    window.location.replace(`${window.location.origin}${NOT_FOUND_PATH}`);
  }
}

export function navigateTo(to: string, options?: { replace?: boolean }): void {
  const currentKey = getBrowserLocationKey();
  const targetKey = normalizeTargetLocation(to);
  if (currentKey !== null && currentKey === targetKey) {
    return;
  }
  if (navigateImpl) {
    navigateImpl(to, options ?? { replace: false });
  } else if (typeof window !== 'undefined') {
    const url = `${window.location.origin}${to}`;
    if (options?.replace) {
      window.location.replace(url);
    } else {
      window.location.assign(url);
    }
  }
}
